import React, { useCallback, useEffect, useState } from "react";
import { debounce } from "../helpers/global";
import useToast from "../hooks/useToast";

// @TODO: refactor this component along with all cart components and have a useCart hook
export function CustomAmountForm({
  submitActive,
  setSubmitActive,
  item,
  customAmountFocus,
  setCustomAmountFocus,
  handleSubmit,
  onClickSubmit,
  register,
  isMiniCart,
  customAmount,
  onSubmitItem,
  errors,
  setError,
  clearErrors,
  setItemPrice,
  isLoadingCustomAmount,
  setIsLoadingCustomAmount,
  setEditStateItems,
  editStateItems,
}) {
  const [shouldValidate, setShouldValidate] = useState(false);
  const fieldName = `donation_amount${item.id}`;
  function getNotifyCustomAmountError(action) {
    return useToast({
      type: "error",
      id: "customAmount",
      actionText: "RETRY?",
      action: async () => await action(),
      dismissable: true,
      message: "There was a problem validating your custom amount.",
    });
  }

  async function validateCustomAmount(amount) {
    const notifyCustomAmountError = getNotifyCustomAmountError(() => {
      validateCustomAmount(amount);
    });
    if (!customAmountFocus) {
      return clearErrors();
    }
    const isEmpty = !amount || parseFloat(amount) === 0.0;
    const isValid = amount && parseFloat(amount) >= 5.0;
    if (isEmpty) {
      clearErrors([fieldName]);
      setSubmitActive(false);
    } else if (isValid) {
      if (!isMiniCart) {
        await onSubmitItem(item, amount)
          .then(() => {
            return item;
          })
          .catch(() => {
            notifyCustomAmountError();
          })
          .finally(() => {
            setEditStateItems([...editStateItems, item.id]);
            setIsLoadingCustomAmount(false);
          });
      }
      setItemPrice(amount);
      clearErrors([fieldName]);
      setSubmitActive(true);
    } else {
      setError(fieldName, {
        type: "manual",
        message: "A minimum donation amount of $5 is required",
      });
      setIsLoadingCustomAmount(false);
      setSubmitActive(false);
    }
    setIsLoadingCustomAmount(false);
  }

  const debouncedValidation = useCallback(
    debounce(validateCustomAmount, 1000),
    [customAmountFocus, item]
  );

  useEffect(() => {
    if (customAmount && shouldValidate) {
      debouncedValidation(customAmount);
    } else {
      setIsLoadingCustomAmount(false);
      setSubmitActive(false);
    }
  }, [customAmount, shouldValidate]);

  useEffect(() => {
    if (customAmountFocus) {
      document.getElementById("donation_amount" + item.id).focus();
    }
  }, [customAmountFocus]);

  function handleChange(e) {
    const field = e.target;
    if (field.value > 1000000) {
      field.value = field.recent;
    }
    // Prevent more than 2 decimal places
    field.value = field.value
      .toString()
      .split(".")
      .map((el, i) => (i ? el.split("").slice(0, 2).join("") : el))
      .join(".");
    // Store previous value in 'old' attribute.
    field.old = field.recent;
    field.recent = field.value;
    const isEmpty = !field.value || parseFloat(field.value) === 0;
    setSubmitActive(!isEmpty);
    setShouldValidate(true);
    setIsLoadingCustomAmount(!isEmpty);
  }

  function handleKeyDown(e) {
    // Prevent exponents and positive/negatives.
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  }

  return (
    <>
      <div className="other-amount-wrapper">
        <div
          className={`other-amount${customAmountFocus ? " has-focus" : ""} ${
            errors[`${"donation_amount" + item.id}`]?.message
              ? " has-error"
              : ""
          }`}
        >
          <button
            className="other-amount__button"
            style={{ color: "white" }}
            onClick={() => {
              setCustomAmountFocus(true);
            }}
          >
            Other amount
          </button>
          <form
            className="other-amount__edit-form"
            onSubmit={handleSubmit((e) => {
              onClickSubmit(isMiniCart, item, e[`donation_amount${item.id}`]);
            })}
            hidden={!customAmountFocus}
            onBlur={(e) => {
              if (!e.target.value) {
                // Show other amount label if we have no value.
                setCustomAmountFocus(false);
              }
            }}
          >
            {customAmountFocus && (
              <input
                className="other-amount__input"
                id={"donation_amount" + item.id}
                name={"donation_amount" + item.id}
                type={"number"}
                autoFocus
                error={errors["donation_amount" + item.id]}
                step={"0.01"}
                onKeyDown={handleKeyDown}
                {...register("donation_amount" + item.id,
                  {
                    onChange: (e) => handleChange(e),
                  }
                )}
                placeholder={"$00.00"}
              />
            )}
            {((!isMiniCart || isLoadingCustomAmount) && (
              <button
                className={`other-amount__submit${
                  isLoadingCustomAmount ? " spinner--before spinner--small" : ""
                }`}
                type="submit"
                disabled={!submitActive || isLoadingCustomAmount}
              >
                <span className="visually-hidden">Update amount</span>
                <span className="icon" aria-hidden="true"></span>
              </button>
            )) ||
              null}
          </form>
        </div>
        {errors[`${"donation_amount" + item.id}`] && (
          <p className="help-tip help-tip--top-right help-tip--other-amount">
            {errors[`${"donation_amount" + item.id}`]?.message}
          </p>
        )}
      </div>
    </>
  );
}
